import { Injectable } from "@angular/core";
import { HandlerService } from "../comunicator-native/handler/handler";
import { DataOrigin } from "../../model/DataOrigin";
import { CustodiaRemuneradaDataMobileService } from "./custodia-remunerada-data-mobile.service";
import { CustodiaRemuneradaMockDataService } from "./custodia-remunerada-data-mock.service";
import { CustodiaRemuneradaDataService } from "./custodia-remunerada-data.service";
import { CaronteCustodiaService } from "../caronte-custodia/caronte-custodia.service";
@Injectable({
  providedIn: "root",
})
export abstract class CustordiaRemuneradaFactoryService {
  private services = new Map<DataOrigin, CustodiaRemuneradaDataService>();

  constructor(
    private custodiaCaronteService: CaronteCustodiaService
  ) {}

  public getService(origin: DataOrigin) {
    if (this.services.has(origin)) {
      return this.services.get(origin);
    } else {
      return this.constructService(origin);
    }
  }

  private constructService(origin: DataOrigin): CustodiaRemuneradaDataService {
    switch (origin) {
      case DataOrigin.Mobile:
        const serviceUserMobile = new CustodiaRemuneradaDataMobileService(this.custodiaCaronteService);
        this.services.set(origin, serviceUserMobile);
        return serviceUserMobile;
      case DataOrigin.Mock:
        const serviceMock = new CustodiaRemuneradaMockDataService();
        this.services.set(origin, serviceMock);
        return serviceMock;
      default:
        const serviceDefault = new CustodiaRemuneradaMockDataService();
        this.services.set(origin, serviceDefault);
        return serviceDefault;
    }
  }
}
